<template>
  <!-- 精品律师解答 -->
  <div class="articgolawer">
    <subTitle text="精选律师解答" />
    <div class="golawerlist">
      <div class="golaweritem" v-for="(item,index) in list" :key="index" @click="tojump(item)">
        <div class="wtbt ellipsis">{{item.title}}</div>
        <div class="wthd">
            {{item.content | toEllipsisFilter(110)}}
          
        </div>
        <div class="wtlabel flex_start">
          <div class="lawin FontSize14">
            <img src="../../../assets/\contmodeldet/law_y_sample.png" /> {{item.true_name}}
          </div>
          <div class="time flex_start FontSize12">
            <img src="../../../assets/claim/time.png" alt="" />{{item.updated_at.substring(0,10)}}
          </div>
          <div class="biaoqian flex_start FontSize12">
            <img src="../../../assets/claimdet/detbaqaicon.png" alt="" />{{item.tag}}
          </div>
          <div class="liulan flex_start FontSize12">
            <img src="../../../assets/base/kan.png" alt="" />{{item.view_num}}次浏览
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "views/home/components/subTitle";
export default {
  props:['list'],
  components: {
    subTitle,
  },
  methods:{
    tojump(item) {
      this.$router.push({
        path: "/laws/articimdet",
        query: {
          articinId: item.id,
        },
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.articgolawer {
  margin-top: 20px;
  width: 100%;
  .golawerlist {
      padding-top:20px ;
    .golaweritem {
      padding: 30px 32px;
      cursor: pointer;
      &:hover {
        .wtbt {
          color: #0465ea;
        }
        box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.08);
      }
      .wtbt {
        font-size: 20px;
        color: #333333;
      }
      .wthd {
        font-size: 14px;
        color: #666666;
        margin: 20px 0;
      }
      .wtlabel {
        color: #999999;
        .lawin {
          img {
            width: 31px;
            height: 32px;
            border-radius: 50%;
          }
        }
        > div {
          margin-right: 30px;
        }
        img {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>